// @flow
/* eslint-disable react/display-name */
import React from "react";
import { List, Datagrid, TextField, DateField, SelectField, EditButton, FunctionField } from "react-admin";
import { GOODS_NAMES } from '../consts'

/* we use perPage={10000} because we don't want to use pagination here. */
export default (props /*: Object */) => (
  <List title="Все товары" {...props} perPage={10000} bulkActionButtons={null}>
    <Datagrid>
      <TextField label="Название" source="name" />
      <FunctionField label="Цена" render={(record /*: Object */) => `₽ ${record.price / 100}`} />
      <SelectField
        label="Тип"
        source="type"
        choices={GOODS_NAMES}
      />
      <DateField showTime label="Дата создания" source="createdAt" />
      <DateField showTime label="Дата редактирования" source="updatedAt" />
      <EditButton />
    </Datagrid>
  </List>
);

/*
  type: GoodType;
  name: string;
  price: number;
  createdAt?: Date;
  updatedAt?: Date;
  _id: Types.ObjectId;
  code?: string;
*/
